const Footer = () => {
  return (
    <div className="flex items-center justify-center w-full h-24 bg-blue-100 p-4  ">
      <span>Copyright © December and Company Inc.</span>
    </div>
  );
};
export default Footer;
